<template>
  <div class="my_data">
    <div class="my_data_title">{{ $t('直属资料') }}
      <div class="input" @click="showFromPicker = true">{{ $format(fromValue, "yy-MM-dd") }}</div>
    </div>
    <div class="data_grid app_card">
      <div class="data_grid_item">
        <div class="label">{{ $t('新增直属') }}</div>
        <div class="value">{{ obj?.today_register_users || 0 }}</div>
      </div>
      <div class="data_grid_item">
        <div class="label">{{ $t('团队人数') }}</div>
        <div class="value">{{ obj?.total_register_users || 0 }}</div>
      </div>
      <div class="data_grid_item">
        <div class="label">{{ $t('今日团队投注') }}</div>
        <div class="value">{{ $money(obj?.today_bet_money || '0.00') }}</div>
      </div>
      <div class="data_grid_item">
        <div class="label">{{ $t('今日佣金') }}</div>
        <div class="value">{{ $money(obj?.today_commission || '0.00') }}</div>
      </div>
      <!-- <div class="data_grid_item">
        <div class="label">{{ $t('代发佣金') }}</div>
        <div class="value">{{ $money('0.00') }}</div>
      </div> -->
    </div>

    <div class="list">
      <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
        :loading-text="$t('Hint.loading')">
        <template v-if="list.length">
          <div v-for="(item, index) in list" :key="`item_${index}`" class="item_wrap app_card">
            <div class="list_head">
              <div class="head_name">{{ item.userphone }}</div>
              <div class="head_id">ID {{ item.id }}</div>
            </div>
            <div class="list_check">
              <div class="check_item">{{ $t('盈亏') }}
                <span :class="[getSum(item) < 0 ? 'red' : 'green']">{{ sumSplit(getSum(item)) }}</span>
              </div>
              <div class="check_item">{{ $t('今日投注') }}<span>{{ $money(item.today_bet_money || '0.00') }}</span></div>
              <div class="check_item">{{ $t('今日佣金') }}<span>{{ $money(item.today_commission || '0.00') }}</span></div>
              <div class="check_item">{{ $t('昨日投注') }}<span>{{ $money(item.yesterday_bet_money || '0.00') }}</span>
              </div>
              <div class="check_item">{{ $t('昨日佣金') }}<span>{{ $money(item.yesterday_commission || '0.00') }}</span>
              </div>
              <div class="check_item">{{ $t('总投注') }}<span>{{ $money(item.total_bet_money || '0.00') }}</span></div>
              <div class="check_item">{{ $t('总佣金') }}<span>{{ $money(item.total_commission || '0.00') }}</span></div>
              <div class="check_time">{{ $format(item.regdate) }}</div>
            </div>
          </div>
        </template>
        <div class="list_not" v-else>
          <img :src="require('@/assets/Img/null/null.png')" alt="">
          <span>{{ $t('目前尚无直接用户') }}</span>
        </div>
      </List>
    </div>
    <Popup v-model="showFromPicker" position="bottom">
      <DatetimePicker v-model="fromValue" :min-date="minDate" :max-date="maxDate" type="date" title=""
        @confirm="(value) => dateSelectChange(value)" @cancel="showFromPicker = false"
        :confirm-button-text="$t('My.Button.Two')" :cancel-button-text="$t('My.Button.One')" />
    </Popup>
  </div>
</template>
<script>
import { AGENT_SUMMARY } from "@/api"
import { post } from "@/utils/newRequest";
import { List, Popup, DatetimePicker } from "vant"
export default {
  components: {
    List, Popup, DatetimePicker
  },
  data() {
    return {
      obj: {},
      list: [],
      page: 0,
      loading: false,
      hasMore: true,
      showFromPicker: false,
      fromValue: new Date(),
      maxDate: new Date(),

    }
  },
  created() {
    this.getData()
  },
  computed: {
    minDate() {
      return new Date(this.maxDate.getTime() - 30 * 24 * 60 * 60 * 1000);
    }
  },
  methods: {
    getSum(item) {
      return Number((Number(item.today_win_money || 0) - Number(item.today_bet_money || 0)).toFixed(5))
    },
    sumSplit(_num) {
      if (!_num) return `${this.verConfig.moneyType} ${_num}`;

      if (_num < 0) {
        return `- ${this.verConfig.moneyType} ${Math.abs(_num)}`
      }
      return `${this.verConfig.moneyType} ${_num}`
    },
    dateSelectChange(value) {
      this.showFromPicker = false
      this.fromValue = value
      this.page = 0;
      this.getData();
      this.getList(true);
    },
    async getData() {
      try {
        const res = await AGENT_SUMMARY({ date: this.$format(this.fromValue, 'yyyy-MM-dd') });
        this.obj = res.data
      } catch (error) { }
    },
    async getList(lower = false) {
      if (!lower) {
        this.page++;
      }
      this.loading = false
      try {
        const { lists, hasMorePages, total: _total } = await post("/agent/users/lists", {
          pagesize: 20,
          page: this.page,
          date: this.$format(this.fromValue, 'yyyy-MM-dd')
        });
        const realList = lists;
        this.hasMore = hasMorePages;
        if (lower) {
          this.list = [...realList]
        } else {
          this.list = [...this.list, ...realList];
        }
        this.loading = false;
      } catch (error) {
        this.loading = true;
        this.page--;
      }
    },
  }
}
</script>
<style lang="less" scoped>
.my_data {
  .my_data_title {
    margin: 18px 0 12px;
    font-size: 17px;
    font-weight: 800;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;

    .input {
      padding: 10px 12px;
      border-radius: 6px;
      border: 1px solid #333;
      font-weight: 100;
    }
  }

  .data_grid {
    padding: 16px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;

    .data_grid_item {
      padding: 14px 10px;
      border-radius: 16px;
      background: #0f172a0a;

      .label {
        color: #7a8597;
        font-size: 12px;
      }

      .value {
        color: #0f172a;
        font-size: 16px;
        margin-top: 8px;
        font-weight: 600;
      }
    }
  }

  .list {
    margin-top: 12px;

    :deep(.van-list) {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .item_wrap {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 12px;
      border-radius: 16px;
      // background: #0f172a0a;

      .list_head {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .head_name {
          font-size: 16px;
          color: #0f172a;
          font-weight: 600;
        }

        .head_id {
          font-size: 12px;
          color: #7a8597;
        }
      }

      .list_check {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .check_status {
          width: fit-content;
          color: #31e2a5;
          padding: 6px 12px;
          border: 1px solid #1fe1a53d;
          background: #1fe1a514;
          font-size: 12px;
          border-radius: 100px;
        }

        .check_item {
          font-size: 12px;
          color: #7a8597;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;

          span {
            color: #0f172a;
            font-size: 14px;
            font-weight: 600;
          }
        }

        .check_time {
          font-size: 12px;
          color: #7a8597;
        }
      }

    }
  }

  .list_not {
    padding: 32px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 160px;
      height: 160px;
      display: block;
    }

    span {
      color: #7a8597;
      font-size: 14px;
      padding: 16px 0 14px;
    }
  }
}
.red{
  color: #ff5162 !important;
}
.green {
  color: #0a8754 !important;
}
</style>